export default __webpack_public_path__ + "static/media/forestly-expl-dissect-05b_EN.152d11c1.png";